import ShortDescriptionMessage from '../../../../../pages/vip/features/item-status/short-description';

export default ShortDescriptionMessage;
